import React from "react";

import styled, { css, keyframes } from "styled-components";

const defaultBaseColor = "#F8F8F8";

const defaultHighlightColor = "#f2f3f2";

const skeletonKeyframes = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonStyles = css`
  background-color: ${defaultBaseColor};
  background-image: linear-gradient(90deg, ${defaultBaseColor}, ${defaultHighlightColor}, ${defaultBaseColor});
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  display: inline-block;
  line-height: 1;
  width: 100%;
`;

type Props = {
  count: number;
  duration?: number | string;
  circle?: boolean;
  width: any;
  height: any;
};

/**
 * From https://github.com/dvtng/react-loading-skeleton/blob/master/src/skeleton.js
 */
export default function Skeleton({
  count,
  duration,
  width,
  height,
  circle,
  style: customStyle,
  className: customClassName,
}: Props & React.HTMLProps<HTMLSpanElement>) {
  const elements = [];

  for (let i = 0; i < count; i++) {
    const style: any = {};

    if (width !== null) {
      style.width = width;
    }

    if (height !== null) {
      style.height = height;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = "50%";
    }

    let className = "react-loading-skeleton";
    if (customClassName) {
      className += " " + customClassName;
    }

    elements.push(
      <Span
        key={i}
        className={className}
        duration={duration}
        style={{
          ...(customStyle as any),
          ...style,
        }}
      >
        &zwnj;
      </Span>,
    );
  }

  return <span>{elements}</span>;
}

const Span = styled.span<{ duration: any }>`
  ${skeletonStyles}
  animation: ${skeletonKeyframes} ${(props) => props.duration}s ease-in-out infinite
`;

Skeleton.defaultProps = {
  count: 1,
  duration: 1.2,
  width: null,
  wrapper: null,
  height: null,
  circle: false,
};
